import * as React from 'react';
import { 
    Card,
    CardContent,
    Typography,
    List,
    ListItem,
    ListItemText,
    Chip,
    Box,
    Divider,
} from '@mui/material';
import { IDueDate, IPayment } from '../../../../config/due_date';
import '../../../../utils/number_extensions';
import { useGlobalStores } from '../../../../hooks/use_global_stores';

interface IFuturePaymentsProps {
    dueDates: IDueDate[];
}

export const FuturePayments = ({dueDates}: IFuturePaymentsProps) => {
    const { currencyStore } = useGlobalStores();

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Upcoming Payments
                </Typography>
                {!dueDates.length ? (
                    <Typography variant="h6" color="text.secondary" align="center">
                        No upcoming payments scheduled
                    </Typography>
                ) : (
                    <List sx={{padding: 0}} dense>
                        {dueDates.map((dueDate: IDueDate, index: number) => (
                            <React.Fragment key={dueDate.due_date.valueOf()}>
                                <ListItem sx={{paddingLeft: 0}}>
                                    <ListItemText
                                        disableTypography
                                        primary={
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography variant="subtitle1">
                                                        {dueDate.due_date.format('MMM D, YYYY')}
                                                    </Typography>
                                                    <Chip 
                                                        size="small" 
                                                        label={dueDate.due_date.fromNow()} 
                                                        color="primary" 
                                                        variant="outlined"
                                                    />
                                                </Box>
                                                <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
                                                    {(dueDate.payments.reduce((sum: number, payment: IPayment) => sum + payment.amount, 0) as any).toCurrency(currencyStore.currentCurrency)}
                                                </Typography>
                                            </Box>
                                        }
                                        secondary={
                                            <List dense disablePadding>
                                                {dueDate.payments.map((payment: IPayment) => (
                                                    <ListItem key={payment.payment_id} disablePadding>
                                                        <ListItemText
                                                            primary={payment.payment_name}
                                                            secondary={(payment.amount as any).toCurrency(currencyStore.currentCurrency)}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        }
                                    />
                                </ListItem>
                                {index < dueDates.length - 1 && <Divider />}
                            </React.Fragment>
                        ))}
                    </List>
                )}
            </CardContent>
        </Card>
    );
};
